import { takeLatest } from 'redux-saga/effects';
import {
	getRegisteredUsersChartSuccess, getRegisteredUsersChartFail,
	getRegisteredAnimalsChartSuccess, getRegisteredAnimalsChartFail,
	getAnimalsStatusChartSuccess, getAnimalsStatusChartFail,
	getWidgetDataSuccess, getWidgetDataFail,
	getTopFarmersSuccess, getTopFarmersFail,
	getFarmLocationsSuccess, getFarmLocationsFail,
	getTopCarabaoFarmersSuccess, getTopCarabaoFarmersFail,
  	getTopCattleFarmersSuccess, getTopCattleFarmersFail,
  	getTopGoatFarmersSuccess, getTopGoatFarmersFail,
  	getTopSheepFarmersSuccess, getTopSheepFarmersFail,
  	getTopSwineFarmersSuccess, getTopSwineFarmersFail,
  	getTopChickenFarmersSuccess, getTopChickenFarmersFail,
  	getTopDuckFarmersSuccess, getTopDuckFarmersFail
} from './dashboardState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const dashboardService = createCrudService('api/v1/admin/dashboard');

function* getRegisteredUsersChart(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`graphs/registered-users`, data.payload), 
		getRegisteredUsersChartSuccess, 
		getRegisteredUsersChartFail);
}

function* getRegisteredAnimalsChart(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`graphs/registered-animals`, data.payload), 
		getRegisteredAnimalsChartSuccess, 
		getRegisteredAnimalsChartFail);
}

function* getAnimalsStatusChart(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`graphs/animals-status`, data.payload), 
		getAnimalsStatusChartSuccess, 
		getAnimalsStatusChartFail);
}

function* getWidgetData(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`widgets/all`, data.payload), 
		getWidgetDataSuccess, 
		getWidgetDataFail);
}

function* getTopFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, data.payload), 
		getTopFarmersSuccess, 
		getTopFarmersFail);
}

function* getFarmLocations(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/farm-locations`, data.payload), 
		getFarmLocationsSuccess, 
		getFarmLocationsFail);
}

function* getTopCarabaoFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'carabao'}), 
		getTopCarabaoFarmersSuccess, 
		getTopCarabaoFarmersFail);
}

function* getTopCattleFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'cattle'}), 
		getTopCattleFarmersSuccess, 
		getTopCattleFarmersFail);
}

function* getTopGoatFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'goat'}), 
		getTopGoatFarmersSuccess, 
		getTopGoatFarmersFail);
}

function* getTopSheepFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'sheep'}), 
		getTopSheepFarmersSuccess, 
		getTopSheepFarmersFail);
}

function* getTopSwineFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'swine'}), 
		getTopSwineFarmersSuccess, 
		getTopSwineFarmersFail);
}

function* getTopChickenFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'chicken'}), 
		getTopChickenFarmersSuccess, 
		getTopChickenFarmersFail);
}

function* getTopDuckFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, {...data.payload, type:'duck'}), 
		getTopDuckFarmersSuccess, 
		getTopDuckFarmersFail);
}

function* dashboardSaga() {
	yield takeLatest('dashboard/getRegisteredUsersChart', getRegisteredUsersChart);
	yield takeLatest('dashboard/getRegisteredAnimalsChart', getRegisteredAnimalsChart);
	yield takeLatest('dashboard/getAnimalsStatusChart', getAnimalsStatusChart);
	yield takeLatest('dashboard/getWidgetData', getWidgetData);
	yield takeLatest('dashboard/getTopFarmers', getTopFarmers);
	yield takeLatest('dashboard/getFarmLocations', getFarmLocations);
	yield takeLatest('dashboard/getTopCarabaoFarmers', getTopCarabaoFarmers);
	yield takeLatest('dashboard/getTopCattleFarmers', getTopCattleFarmers);
	yield takeLatest('dashboard/getTopGoatFarmers', getTopGoatFarmers);
	yield takeLatest('dashboard/getTopSheepFarmers', getTopSheepFarmers);
	yield takeLatest('dashboard/getTopSwineFarmers', getTopSwineFarmers);
	yield takeLatest('dashboard/getTopChickenFarmers', getTopChickenFarmers);
	yield takeLatest('dashboard/getTopDuckFarmers', getTopDuckFarmers);
}

export default dashboardSaga;
